import { render, staticRenderFns } from "./LoginUser.vue?vue&type=template&id=42644642&scoped=true"
var script = {}
import style0 from "./LoginUser.vue?vue&type=style&index=0&id=42644642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42644642",
  null
  
)

export default component.exports